/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_DaysInputs */

const en_admin_allocation_form_days = /** @type {(inputs: Admin_Allocation_Form_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`days`)
};

const de_admin_allocation_form_days = /** @type {(inputs: Admin_Allocation_Form_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tage`)
};

const es_admin_allocation_form_days = /** @type {(inputs: Admin_Allocation_Form_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`días`)
};

const fr_admin_allocation_form_days = /** @type {(inputs: Admin_Allocation_Form_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`jours`)
};

/** @type {(inputs: Admin_Allocation_Form_DaysInputs) => LocalizedString} */
const it_admin_allocation_form_days = en_admin_allocation_form_days;

/** @type {(inputs: Admin_Allocation_Form_DaysInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_days = en_admin_allocation_form_days;

/** @type {(inputs: Admin_Allocation_Form_DaysInputs) => LocalizedString} */
const pl_admin_allocation_form_days = en_admin_allocation_form_days;

/** @type {(inputs: Admin_Allocation_Form_DaysInputs) => LocalizedString} */
const hu_admin_allocation_form_days = en_admin_allocation_form_days;

/** @type {(inputs: Admin_Allocation_Form_DaysInputs) => LocalizedString} */
const ro_admin_allocation_form_days = en_admin_allocation_form_days;

/**
* | output |
* | --- |
* | "days" |
*
* @param {Admin_Allocation_Form_DaysInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_days = /** @type {((inputs?: Admin_Allocation_Form_DaysInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_DaysInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_days(inputs)
	if (locale === "de") return de_admin_allocation_form_days(inputs)
	if (locale === "es") return es_admin_allocation_form_days(inputs)
	if (locale === "fr") return fr_admin_allocation_form_days(inputs)
	if (locale === "it") return it_admin_allocation_form_days(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_days(inputs)
	if (locale === "pl") return pl_admin_allocation_form_days(inputs)
	if (locale === "hu") return hu_admin_allocation_form_days(inputs)
	return ro_admin_allocation_form_days(inputs)
});
export { admin_allocation_form_days as "admin.allocation_form.days" }